// extracted by mini-css-extract-plugin
export default {"wrapper":"StoriesLoader_wrapper__WVgCT"};